/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable prettier/prettier */
import { hot } from 'react-hot-loader'
import React from 'react'
import styled from 'styled-components'
import Banner from '../components/Banner/Banner'
import { Benefits } from '../components/Benefits/Benefits'
import { PointsForts } from '../components/PointsForts/PointsForts'
import { History } from '../components/History/History'
import { Presse } from '../components/Presse/Presse'
import { Trustpilot } from '../components/Trustpilot/Trustpilot'
import { QA } from '../components/QA/QA'
import Hero from '../components/Hero/Hero'

const StyledBrandingContainer = styled.div``

function App() {
  return (
    <StyledBrandingContainer>
      <Banner />
      <Hero />
      {/* <FormContainer /> */}
      {/* <PartnersContainer /> */}
      {/* <Avis /> */}
      {/* <FormReminder /> */}
      <Benefits />
      <Trustpilot />
      <PointsForts />
      <History />
      <Presse />
      <QA />
    </StyledBrandingContainer>
  )
}

export default hot(module)(App)
